import {StrydStripePrice, OneTimeStripePrice} from 'src/features/pricing/types';

export const isOneTimeStripePrice = (
  price: StrydStripePrice
): price is OneTimeStripePrice => {
  return price.type === 'one_time';
};
